<template>
    <div class="au-card au-stat">
        <div class="au-tile" :class="`is-${tone}`"><i :class="['bi', icon]"></i></div>
        <div>
            <div v-if="loading" class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">{{ $t("common.loading") }}</span>
            </div>
            <div v-else class="au-stat-value" :class="{ 'is-text': isText }">{{ value }}</div>
            <div class="au-stat-label">{{ label }}</div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "StatCard",
    props: {
        icon: { type: String, required: true },
        tone: {
            type: String,
            default: "indigo",
            validator: (value: string) => ["indigo", "cyan", "rose", "amber", "emerald"].includes(value)
        },
        value: { type: [String, Number], default: "" },
        label: { type: String, required: true },
        loading: { type: Boolean, default: false },
        isText: { type: Boolean, default: false },
    },
});
</script>
